'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    padding: 1em;\n    background: ', ';\n    display: flex; \n    flex-wrap: wrap;\n    > * {\n        flex: 1 1 300px;\n    }\n\n    .title, .copyright{\n        flex: 100%;\n        display: flex; \n        justify-content: center;\n    }\n    .title{\n        color: #43E896;\n    }\n\n'], ['\n    padding: 1em;\n    background: ', ';\n    display: flex; \n    flex-wrap: wrap;\n    > * {\n        flex: 1 1 300px;\n    }\n\n    .title, .copyright{\n        flex: 100%;\n        display: flex; \n        justify-content: center;\n    }\n    .title{\n        color: #43E896;\n    }\n\n']);

exports.Footer = Footer;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var FooterStyles = _styledComponents2.default.footer(_templateObject, function (_ref) {
  var theme = _ref.theme;
  return theme.middleground;
});

function Footer() {
  return _react2.default.createElement(FooterStyles, null, _react2.default.createElement('div', {
    className: 'title'
  }, _react2.default.createElement('a', {
    href: 'https://zyppd.in'
  }, _react2.default.createElement('h3', null, 'zyppd.in'))), _react2.default.createElement('p', {
    className: 'copyright'
  }, '\xA9 ', new Date().getFullYear(), ' zyppd.in'));
}